import React from 'react';
import { useBranding } from '@/contexts/shared/BrandingContext';
import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  const { footerText } = useBranding();

  if (!footerText) return null;

  return (
    <footer className={styles.footer}>
      <span className={styles.text}>{footerText}</span>
    </footer>
  );
};
